import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'item']

  connect() {
    this.type = this.data.get('type') || 'expandable'
    this.active = null
  }

  select(e) {
    if (this.active == this.getItem(e)) {
      this.closeActive()
    } else {
      if (this.type == 'accordion' && this.active) {
        this.closeActive()
      }
      this.active = this.getItem(e)
      this.active.dropdown.open()
    }
  }

  closeActive() {
    this.active.dropdown.closeImmediately()
    this.active = null
  }

  getItem(e) {
    return e.currentTarget.parentNode.parentNode
  }
}
